var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 5)?_c('div',{style:(`padding: ${_vm.componentsData.content.marginData.top}px ${_vm.componentsData.content.marginData.left}px;`)},[(_vm.hasPicview)?_c('imgStyle',{staticClass:"img-style",attrs:{"imageData":_vm.componentsData,"imgList":[]}}):_c('div',{staticClass:"none-div"},[_vm._v("请上传图片")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }